import { MEDIA_QUERIES } from '../utils/breakpoints.js';

export function initTopFunctions() {
    gsap.registerPlugin(ScrollTrigger);
    
    document.addEventListener("DOMContentLoaded", (event) => {
        let topKvAnimationItem = document.querySelectorAll('.js-topKvAnimationItem');
        
        let kvTl = gsap.timeline({
            delay: 0.5,
            onComplete: () => {
                const kvSliders = $('.js-kvSlider');

                if (kvSliders.length > 0) {
                    const totalSliders = kvSliders.length;
                    const staggerMs = 500;
                    const waitAfterAllMs = 2000;
                    
                    const autoplayDelay = ((totalSliders - 1) * staggerMs) + waitAfterAllMs;

                    kvSliders.each(function () {
                        let dataOrder = $(this).data('order');
                        let order = dataOrder !== undefined && dataOrder !== null ? Number(dataOrder) : 0;
                        
                        let swiper = new Swiper(this, {
                            loop: true,
                            effect: "fade",
                            speed: 2000,
                            allowTouchMove: false,
                            autoplay: {
                                delay: autoplayDelay,
                                disableOnInteraction: false,
                            },
                        });
                        
                        swiper.autoplay.stop();

                        setTimeout(() => {
                            swiper.slideNext();
                            swiper.autoplay.start();
                        }, (order > 0 ? order - 1 : 0) * staggerMs);
                    });
                }
            }
        });

        topKvAnimationItem.forEach((item, index) => {
            let delay = item.dataset.order ? ( Number(item.dataset.order) * 0.5 ) : 0;
            let opacity = item.dataset.opacity ? Number(item.dataset.opacity) : 1;
            kvTl.to(item, {opacity: opacity, duration: 1, delay: delay}, 0);
        });
    });

    //topFeature Animation
(function(){
    let featureItem = document.querySelectorAll('.js-featureAnimation');

    featureItem.forEach((item) => {
        let title = item.querySelector('.topHeading');
        let images = item.querySelectorAll('.imgContainer__item');
        let text = item.querySelector('.featureItem__content__text');

        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: item,
                start: "top 85%",
            }
        });

        tl.fromTo(title, 
            { opacity: 0 }, 
            { opacity: 1, duration: 1.8, ease: "sine.out" }
        )
        .fromTo(images, 
            { opacity: 0 }, 
            { 
                opacity: 1, 
                duration: 4, 
                stagger: 0.2,
                ease: "sine.out"
            }, 
            "<"
        )
        .fromTo(text, 
            { opacity: 0 }, 
            { opacity: 1, duration: 1.8, ease: "sine.out" }, 
            "-=3.8"
        );
    });
})();

    //topFeature Animation Reverse
    (function(){
        let featureItemReverse = document.querySelectorAll('.js-featureAnimationReverse');
        featureItemReverse.forEach((item) => {
            let title = item.querySelector('.topHeading');
            let images = Array.from(item.querySelectorAll('.imgContainer__item')).reverse();
            let text = item.querySelector('.featureItem__content__text');

            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: item,
                    start: "top 85%",
                }
            });

        tl.fromTo(title, 
            { opacity: 0 }, 
            { opacity: 1, duration: 1.8, ease: "sine.out" }
        )
        .fromTo(images, 
            { opacity: 0 }, 
            { 
                opacity: 1, 
                duration: 4, 
                stagger: 0.2,
                ease: "sine.out"
            }, 
            "<"
        )
        .fromTo(text, 
            { opacity: 0 }, 
            { opacity: 1, duration: 1.8, ease: "sine.out" }, 
            "-=3.8"
        );
        });
    })();

    //top Animation
    (function(){
        let flowItem = document.querySelectorAll('.js-topFade');
        flowItem.forEach((item) => {
            let items = item.querySelectorAll('.js-topFadeItem');
            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: item,
                    start: "top 70%",
                    ease: "power2.in",
                }
            });

            tl.fromTo(items, {opacity: 0}, {opacity: 1, duration: 0.8, stagger: 0.3});
        });
    })();

}
